import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AdminProvider } from "./context/AdminContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "./components/Layout";
import Calculator from "./components/Calculator";
import QuoteHistory from "./pages/QuoteHistory";
import LeadsAdmin from "./pages/LeadsAdmin";
import AdminDashboard from "./pages/AdminDashboard";
import SharedQuote from "./pages/SharedQuote";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import RodoClause from "./pages/legal/RodoClause";
import TermsOfService from "./pages/legal/TermsOfService";
import PaymentTerms from "./pages/legal/PaymentTerms";
import CookiePolicy from "./pages/legal/CookiePolicy";

function App() {
  return (
    <LanguageProvider>
      <AdminProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Calculator />} />
              <Route path="/history" element={<QuoteHistory />} />
              <Route path="/leads" element={<LeadsAdmin />} />
              <Route path="/dashboard" element={<AdminDashboard />} />
              <Route path="/quote/:id" element={<SharedQuote />} />
              <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
              <Route path="/rodo" element={<RodoClause />} />
              <Route path="/regulamin" element={<TermsOfService />} />
              <Route path="/regulamin-platnosci" element={<PaymentTerms />} />
              <Route path="/cookies" element={<CookiePolicy />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AdminProvider>
    </LanguageProvider>
  );
}

export default App;
